import { render, staticRenderFns } from "./PanoramaControls.vue?vue&type=template&id=356b0b7d"
import script from "./PanoramaControls.vue?vue&type=script&lang=js"
export * from "./PanoramaControls.vue?vue&type=script&lang=js"
import style0 from "./PanoramaControls.vue?vue&type=style&index=0&id=356b0b7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports